// extracted by mini-css-extract-plugin
export var closeButton = "_ps-2";
export var closeButtonIcon = "_ps-3";
export var lightboxContent = "_ps-1";
export var lightboxOverlay = "_ps-0";